import { mockComponent } from 'bloko/common/setupMockComponents';

export const TabDropdown = mockComponent('TabDropdown', null, {
    withChildren: true,
});

export const TabItem = mockComponent('TabItem', null, {
    withChildren: true,
});

export default mockComponent('Tab', null, {
    withChildren: true,
});
